export default __webpack_public_path__ + "static/media/axa_logo-01.75a4487d.svg";